import React from "react";
import Pod from "carbon-react/lib/components/pod";
import Link from "carbon-react/lib/components/link";
import Content from "carbon-react/lib/components/content";
import { Row, Column } from "carbon-react/lib/components/row";

import "./SimpleTablePager.css";

const SimpleTablePager = ({
  appearBusy,
  pageNo,
  lastPage,
  onPagePrev,
  onPageNext,
}) => {
  const enablePrev = pageNo && pageNo > 1;

  const onPrevClicked = () => {
    if (onPagePrev && typeof onPagePrev === "function") onPagePrev();
  };

  const onNextClicked = () => {
    if (onPageNext && typeof onPageNext === "function") onPageNext();
  };

  return (
    <Pod className="simple-table-pager" podType="secondary">
      <Row columns="9">
        <Column columnSpan="4" columnAlign="right">
          <Link
            id="simple-table-pager-prev-btn"
            onClick={onPrevClicked}
            {...(appearBusy || !enablePrev ? { disabled: true } : {})}
            className="user-logs-table-pager-link"
          >
            Previous
          </Link>
        </Column>
        <Column columnAlign="center">
          <Content as="primary">{`Page ${pageNo || 1}`}</Content>
        </Column>
        <Column columnSpan="4" columnAlign="left">
          <Link
            id="simple-table-pager-next-btn"
            onClick={onNextClicked}
            {...(appearBusy || lastPage ? { disabled: true } : {})}
            className="user-logs-table-pager-link"
          >
            Next
          </Link>
        </Column>
      </Row>
    </Pod>
  );
};

export default SimpleTablePager;
